import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const products = [{
  title: "Equipment nameplates",
  description: "Product ID and rating nameplates applied to every unit built.",
  link: "/products/engraved-nameplates/equipment-nameplates/"
}, {
  title: "Data plates",
  description: "Model, serial, rating, and certification-field data plates.",
  link: "/products/engraved-nameplates/equipment-nameplates/"
}, {
  title: "Direct part marking (DPM)",
  description: "Serialized 2D data matrix and part marks for traceability.",
  link: "/services/laser-marking-direct-part/"
}, {
  title: "Asset & ID tags",
  description: "Numbered, serialized tags for the products you ship.",
  link: "/products/engraved-nameplates/asset-tags/"
}, {
  title: "Metal & phenolic engraving",
  description: "Material matched to the product and its environment.",
  link: "/services/laser-engraving-metal/"
}, {
  title: "MIL-SPEC phenolic",
  description: "For OEMs supplying defense, marine, or aerospace programs.",
  link: "/products/mil-spec-phenolic/"
}];
export default function WhatEvermarkSuppliesOems() {
  return <section id="what-evermark-supplies-oems" className="bg-background">
      <div className="bg-[#0F1B2D] py-16 md:py-24 lg:py-32">
        <div className="container mx-auto px-4 md:px-6">
          <div className="mb-12 max-w-3xl">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              What Does Evermark Produce for OEMs?
            </h2>
            <p className="text-lg md:text-xl text-[#E8E4DC] leading-relaxed">
              The recurring marking Evermark Industrial Solutions supplies to OEM equipment manufacturers:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {products.map((product, i) => <div key={i} data-index={i} className="h-full">
                <Link to={product.link} className="block h-full group outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-xl">
                  <Card className="h-full bg-card border-border/50 group-hover:border-primary/70 transition-all duration-300 group-hover:shadow-md group-hover:-translate-y-1 flex flex-col">
                    <CardHeader className="pb-4">
                      <div className="flex items-start justify-between gap-4">
                        <CardTitle className="text-xl text-card-foreground font-default group-hover:text-primary transition-colors">
                          {product.title}
                        </CardTitle>
                        <ArrowRight className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors shrink-0 mt-0.5" />
                      </div>
                    </CardHeader>
                    <CardContent className="flex-grow">
                      <p className="text-muted-foreground leading-relaxed">
                        {product.description}
                      </p>
                    </CardContent>
                  </Card>
                </Link>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}